export const AllVpcInfo = 'step3/AllVpcInfo';
export const AllocatedAdrList = 'step3/AllocatedAdrList';
export const DescribePrivateIpAddressAttributes = 'step3/DescribePrivateIpAddressAttributes';
export const AdrList = 'step3/AdrList';
export const DescribeSubnets = 'step3/DescribeSubnets';
export const AdrCount = 'step3/AdrCount';

//获取支持IPV6的机型ProductTypeId的数据
export const getIpv6SupportProductType = 'step3/getIpv6SupportProductType';
export const ValidateIpv6Support = 'step3/ValidateIpv6Support';

export const QueryProductNetworkInterfaceQuota = 'step3/QueryProductNetworkInterfaceQuota';

export const DescribeSecurityGroupsQuota = 'step3/DescribeSecurityGroupsQuota';

//--以下为未登录constants--
export const noLoginAllVpcInfo = 'step3/noLoginAllVpcInfo';
export const noLoginAdrList = 'step3/noLoginAdrList';
//--以上为未登录constants--